import {
  call,
  put,
  takeLatest,
  delay,
  select
} from 'redux-saga/effects'
import Router from 'next/router'

import { TentativeParents } from 'services/api/entities'
import { TentativeParentsActionCreators } from 'app/reducers/TentativeParentsRedux'
import { AlertActionCreators } from 'app/reducers/AlertRedux'
import { getProfileInfoDataSelector } from 'app/selectors/user'

export function* all({ params }) {
  const response = yield TentativeParents.all(params)

  if (response.success()) {
    yield put(
      TentativeParentsActionCreators.allSuccess(
        response.data
      )
    )
  } else {
    yield put(TentativeParentsActionCreators.allFailure(response.data))
  }
}

export function* search({ searchTerm }) {
  const response = yield TentativeParents.search(searchTerm)

  if (response.success()) {
    yield put(
      TentativeParentsActionCreators.searchSuccess(
        response.data.results
      )
    )
  } else {
    yield put(TentativeParentsActionCreators.searchFailure(response.data))
  }
}

export function* remove({ agentId }) {
  const response = yield TentativeParents.remove(agentId)

  if (response.success()) {
    yield put(
      TentativeParentsActionCreators.removeSuccess(agentId)
    )
  } else {
    yield put(TentativeParentsActionCreators.removeFailure(response.data))
  }
}

export function* choose({ agentId }) {
  const response = yield TentativeParents.choose(agentId)

  if (response.success()) {
    yield put(
      TentativeParentsActionCreators.chooseSuccess(agentId)
    )
    // Show success message
    yield put(
      AlertActionCreators.success({
        message: 'Padrino seleccionado'
      })
    )
    // Wait 1 seconds to let user see the success message
    yield delay(1000)
    // Reload the page after successful selection
    Router.reload()
  } else {
    const errors = {
      ...(response.data.errors || {}),
      // general error not related to the parent
      // instead related to the user that is choosing
      ...(response.data.errors.error && { error: response.data.errors.error })
    }

    yield put(TentativeParentsActionCreators.chooseFailure(
      errors,
      agentId
    ))
  }
}

export function* checkParentSelectorPermissions() {
  try {
    // Get user info from auth profile (same as Profile component)
    const userInfo = yield select((state) => state.auth.profile)

    if (!userInfo) {
      return
    }

    // Get profile info data (same as Profile component)
    const profileInfo = yield select(getProfileInfoDataSelector)

    // Check if user is self-service (same condition as in Profile component)
    if (!userInfo.isSelfService) {
      return
    }

    // Check if user has root parent (same condition as in Profile component)
    if (!profileInfo.hasRootParent) {
      return
    }

    // Check if user has never changed parent (same condition as in Profile component)
    if (profileInfo.hasSelfChangeParent) {
      return
    }

    // Calculate days since user creation
    const { createdAt } = userInfo
    if (!createdAt) {
      return
    }

    const createdDate = new Date(createdAt)
    const currentDate = new Date()
    const daysDifference = Math.floor((currentDate - createdDate) / (1000 * 60 * 60 * 24))

    // Show modal if 30 or more days have passed and all conditions are met
    if (daysDifference >= 30) {
      yield put(TentativeParentsActionCreators.setShouldShowModal(true))
    }
  } catch (error) {
    console.error('Error checking parent selector permissions:', error)
  }
}
